import { APIScope, FeatureFlagKey } from "@swivl-mono/types";
import { LayoutWithSidebar } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { ShowIf } from "../../Components/ShowIf/ShowIf";
import { SidebarLink } from "../../Components/SidebarLink/SidebarLink";
import { isFeatureEnabled } from "../../Helpers/FeatureFlags/isFeatureEnabled";
import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";
import { Member } from "../../Models/Member/Member.Current";
import { NavBar } from "../../Models/NavBar/NavBar.Model";

export function SettingsView() {
  // Legacy Sequences, Escalation Groups, Escalation History and Workflows go with the
  // legacy nav when an org on Snowy hides it (ENG-3490). Same double guard as NavDrawer.
  const legacyHidden = isFeatureEnabled(FeatureFlagKey.HideLegacyNav) && isFeatureEnabled(FeatureFlagKey.Snowy);
  const hasFmsEditPermission = useHasPermission(APIScope.FMS_EDIT);

  useEffect(() => {
    NavBar.set(<NavBar.Component.Title title="Settings" />, null, null, "Settings");
  }, []);

  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          <SidebarLink to="/settings/analytics">Analytics</SidebarLink>
          <ShowIf scope={APIScope.ROLES_VIEW}>
            <SidebarLink to="/settings/roles">Roles</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.MEMBERS_GET}>
            <SidebarLink to="/settings/members">Members</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.APPS_EDIT}>
            <SidebarLink to="/settings/apps">Apps</SidebarLink>
          </ShowIf>
          {hasFmsEditPermission && <SidebarLink to="/settings/fms-integrations">FMS Integrations</SidebarLink>}
          {!legacyHidden && (
            <>
              <ShowIf scope={APIScope.ESCALATIONS_EDIT}>
                <SidebarLink to="/settings/escalations">Escalation Groups</SidebarLink>
              </ShowIf>
              <ShowIf scope={APIScope.ESCALATIONS_EDIT}>
                <SidebarLink to="/settings/escalation-history">Escalation History</SidebarLink>
              </ShowIf>
            </>
          )}
          <ShowIf scope={APIScope.TICKETS_EDIT}>
            <SidebarLink to="/settings/ticket-templates">Ticket Templates</SidebarLink>
          </ShowIf>
          {!legacyHidden && (
            <ShowIf scope={APIScope.SEQUENCES_VIEW}>
              <SidebarLink to="/settings/sequences">Sequences</SidebarLink>
            </ShowIf>
          )}
          {isFeatureEnabled(FeatureFlagKey.Snowy) && (
            <ShowIf scope={APIScope.LOCATION_DETAILS_WRITE}>
              <SidebarLink to="/settings/document-ingest">Document Upload</SidebarLink>
            </ShowIf>
          )}
          {Member.isSwivlStaff && (
            <>
              <SidebarLink to="/settings/interactions">Interactions</SidebarLink>
              <SidebarLink to="/settings/brains">Brains</SidebarLink>
              <SidebarLink to="/settings/ai-assist">AI Assist</SidebarLink>
            </>
          )}
          {!legacyHidden && (
            <ShowIf scope={APIScope.WORKFLOWS_VIEW}>
              <SidebarLink to="/workflows">Workflows</SidebarLink>
            </ShowIf>
          )}
        </div>
      }
      contentNoPadding={true}
      content={<Outlet />}
    />
  );
}
